import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PlasticBag } from '@mafc/icon';
import { Suspense } from 'react';
import { useDispatch } from 'react-redux';
import COLORS from 'theme/colors';
import InfoWrapper from 'common/InfoWrapper/InfoWrapper';
import { PlasticBagPackingInfo } from 'network/response/ICart';
import SingleUsePackageFees from 'common/SingleUsePackageFees/SingleUsePackageFees';

import { userConsentAction } from 'pages/Checkout/redux/actions/consent.action';

import { Flex, Text, Box } from '@mafc/trolly';
import { CookieUtils } from '@mafc/common';
import { setPlasticBagUserConsent } from 'pages/OrderList/redux/plasticBagUserConsent.action';
import LinkActionButton from 'common/LinkActionButton';

const UserConsentBags = React.lazy(() =>
  import('@mafc/common').then(module => ({ default: module.UserConsentBags }))
);

const ChangeButtonRow: React.FC<{
  changeButtonLabelKey: string;
}> = ({ changeButtonLabelKey }) => {
  const { t } = useTranslation();
  const [isConsentFormOpen, toggleConsentForm] = useState(false);
  const closeConsentForm = () => {
    toggleConsentForm(false);
  };
  const openConsentForm = () => {
    toggleConsentForm(true);
  };
  const dispatch = useDispatch();
  const userConsentConfirmation = (data: any) => {
    const isUserConsentChanged = CookieUtils.getPackageFreeDelivery() !== data.toString();
    if (isUserConsentChanged) {
      dispatch(setPlasticBagUserConsent(data));
    }
    const params = {
      isSustainableConsent: data,
    };
    dispatch(userConsentAction(params));
  };
  return (
    <>
      <Flex justifyContent="flex-end" mt="3">
        <LinkActionButton
          label={t(`singleUsePackage.${changeButtonLabelKey}`)}
          onClick={openConsentForm}
          dataTestId="change-plastic-bag-consent-btn"
        />
      </Flex>
      <Suspense fallback={<></>}>
        <UserConsentBags
          isOpen={isConsentFormOpen}
          isFormVisible
          callBack={userConsentConfirmation}
          close={closeConsentForm}
          isShowCloseButton
          isUpdateConsent
        />
      </Suspense>
    </>
  );
};

const Heading = () => {
  const { t } = useTranslation();

  return (
    <Flex alignItems="center" justifyContent="space-between" mb="12px">
      <Text fontSize={3} fontWeight={6} color={COLORS.BLACK}>
        {t('singleUsePackage.packaging')}
      </Text>
    </Flex>
  );
};

const SingleUsePackage: React.FC<{
  plasticBagPackingInfo?: PlasticBagPackingInfo;
  sustainabilityConsent: boolean;
  showHeading?: boolean;
  isConfirmation?: boolean;
}> = ({ plasticBagPackingInfo, showHeading, sustainabilityConsent, isConfirmation = false }) => {
  const { t } = useTranslation();

  return (
    <Box>
      {showHeading && <Heading />}
      {sustainabilityConsent ? (
        <InfoWrapper
          backgroundColor={COLORS.SUCCESS_GREEN}
          icon={<PlasticBag stroke={COLORS.SUCCESS_GREEN_DARK} />}
          headingText={t('singleUsePackage.plasticBagFreeHeading')}
          marginBottom="1px"
        >
          <Text color={COLORS.BLACK}>{t('singleUsePackage.plasticBagFreeDescription')}</Text>
          {!isConfirmation && <ChangeButtonRow changeButtonLabelKey="change" />}
        </InfoWrapper>
      ) : (
        <>
          {plasticBagPackingInfo && (
            <SingleUsePackageFees plasticBagPackingInfo={plasticBagPackingInfo}>
              {!isConfirmation && <ChangeButtonRow changeButtonLabelKey="goBagLess" />}
            </SingleUsePackageFees>
          )}
        </>
      )}
    </Box>
  );
};

export default SingleUsePackage;
